import type { FC, ReactNode } from 'react';

import Footer from '../sections/Footer';
import Header from '../sections/Header';

const GeneralLayout: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <div className="site-shell">
      <Header />
      <main className="site-main">{children}</main>
      <Footer />
    </div>
  );
};

export default GeneralLayout;
